import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SpinnerService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';
import { Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";

@Component({
    selector: 'app-royalties-entidad',
    templateUrl: './royalties.component.html'
})
export class RoyaltiesEntidadControlComponent implements OnInit {

    public disabledDivisas: Subject<boolean> = new Subject();
    public disabledSuperficie: Subject<boolean> = new Subject();
    public disabledNPlantas: Subject<boolean> = new Subject();
    public disabledPeso: Subject<boolean> = new Subject();

    public newEditForm: UntypedFormGroup;

    public onEdit;
    public showError: boolean;

    @Input() entidadControl;
    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter<boolean>();

    constructor(
      private _fb: UntypedFormBuilder,
      private readonly _dataProvider: DataProvider,
      private readonly _spinnerService: SpinnerService,
      private readonly _adminService: AdminService
    ) {}

    ngOnInit() {
      this.newEditForm = this._fb.group({
        divisas: [{ value: this.unidadesDivisas.find(a=>a.id === this.entidadControl.divisaId), disabled: true }, Validators.required],
        superficie: [{ value: this.unidadesSuperficie.find(a=>a.id === this.entidadControl.uM_SuperficieId), disabled: true }, Validators.required],
        plantas: [{ value: this.unidadesNPlantas.find(a=>a.id === this.entidadControl.uM_NPlantasId), disabled: true }, Validators.required],
        peso: [{ value: this.unidadesPeso.find(a=>a.id === this.entidadControl.unidadMedidaId), disabled: true }, Validators.required]
      });
    }

    public get unidadesPeso() {
      return this._dataProvider.unidadesPesoRoyalties;
    }

    public get unidadesDivisas() {
      return this._dataProvider.unidadesDivisasRoyalties;
    }

    public get unidadesSuperficie() {
      return this._dataProvider.unidadesSuperficieRoyalties;
    }

    public get unidadesNPlantas() {
      return this._dataProvider.unidadesNPlantasRoyalties;
    }

    public save(){
      this.checkForm();
      if (this.newEditForm.valid) {
        let filters = {
          id: this.entidadControl.id,
          des: this.entidadControl.des,
          unidadMedidaId: this.newEditForm.get('peso').value.id,
          divisaId: this.newEditForm.get('divisas').value.id,
          uM_SuperficieId: this.newEditForm.get('superficie').value.id,
          uM_NPlantasId: this.newEditForm.get('plantas').value.id
        };
        this.showError = false;
        this._spinnerService.showSpinner();
        this._adminService.updateEntidadControl(filters).toPromise().finally(() => {
          this._spinnerService.hideSpinner();
        }).then((resp) => {
          this.disableFilters();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemUpdated');
        }, (error) => {
          this.showError = true;
          switch (error.error.ApiErrorCode) {
            case 3000: //FuncionalidadRestringida
              this.pushMessage.emit('ApiErrors.FuncionalidadRestringida');
              break;
            case 6142: //EntidadControlNoAccesible
              this.pushMessage.emit('ApiErrors.entidadControlNoAccesible');
              break;
            case 6175: //UnidadMedidaNoAccesible
              this.pushMessage.emit('ApiErrors.unidadMedidaNoAccesible');
              break;
            case 6176: //DivisaNoAccesible
              this.pushMessage.emit('ApiErrors.divisaNoAccesible');
              break;
            case 6177: //UM_SuperficieNoAccesible
              this.pushMessage.emit('ApiErrors.uM_SuperficieNoAccesible');
              break;
            case 6178: //UM_NPlantasNoAccesible
              this.pushMessage.emit('ApiErrors.uM_NPlantasNoAccesible');
              break;
            default:
              this.pushMessage.emit('global.error.noResponse');
              break;
          }
        });
      }
    }

    public enableFilters(){
      this.newEditForm.enable();
      this.disabledDivisas.next(false);
      this.disabledSuperficie.next(false);
      this.disabledNPlantas.next(false);
      this.disabledPeso.next(false);
      this.onEdit = true;
    }

    public disableFilters(){
      this.newEditForm.disable();
      this.disabledDivisas.next(true);
      this.disabledSuperficie.next(true);
      this.disabledNPlantas.next(true);
      this.disabledPeso.next(true);
      this.onEdit = false;
    }

    public cancel(){
      this.newEditForm.reset({
        divisas: this.unidadesDivisas.find(a=>a.id === this.entidadControl.divisaId),
        superficie: this.unidadesSuperficie.find(a=>a.id === this.entidadControl.uM_SuperficieId),
        plantas: this.unidadesNPlantas.find(a=>a.id === this.entidadControl.uM_NPlantasId),
        peso: this.unidadesPeso.find(a=>a.id === this.entidadControl.unidadMedidaId)
      });
      this.disableFilters();
    }

    private checkForm() {
      this.showError = this.newEditForm.invalid;
      if (this.showError) {
        this.pushMessage.emit('global.error.required');
      }
    }
}
